import { z } from "zod";
/** MCP personal access tokens (block 27). */
/** `POST /v1/mcp-tokens`. */
export const createMcpTokenSchema = z.object({ name: z.string().trim().min(1).max(60) });
/** → 201. `token` and `connectorUrl` are returned here once and never again (PRD §8). */
export const createdMcpTokenSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    token: z.string(),
    connectorUrl: z.url(),
    createdAt: z.iso.datetime(),
});
/** Active tokens only (A6 C10). Never the token or its hash. */
export const mcpTokenSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    createdAt: z.iso.datetime(),
    lastUsedAt: z.iso.datetime().nullable(),
});
/** `GET /v1/mcp-tokens`. */
export const mcpTokenListSchema = z.object({ items: z.array(mcpTokenSchema) });
//# sourceMappingURL=mcp-token.js.map